import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with defaults
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 30000
});

// Request interceptor for logging (dev only)
apiClient.interceptors.request.use(
  (config) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('API Request:', config.method?.toUpperCase(), config.url);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (process.env.NODE_ENV === 'development') {
      console.error('API Error:', error.response?.data || error.message);
    }
    return Promise.reject(error);
  }
);

// Jobs API
export const jobsApi = {
  getAll: (params = {}) => apiClient.get('/jobs', { params }),
  getById: (id) => apiClient.get(`/jobs/${id}`),
  create: (data) => apiClient.post('/jobs', data),
  update: (id, data) => apiClient.put(`/jobs/${id}`, data),
  delete: (id) => apiClient.delete(`/jobs/${id}`),
  getDepartments: () => apiClient.get('/jobs/departments/list'),
  getSkills: () => apiClient.get('/jobs/skills/list'),
};

// Contact API
export const contactApi = {
  submit: (data) => apiClient.post('/contact', data),
  getSubmissions: (params = {}) => apiClient.get('/contact/submissions', { params }),
  updateStatus: (id, status) => apiClient.put(`/contact/submissions/${id}/status?status=${status}`),
};

// Applications API
export const applicationsApi = {
  submit: (data) => apiClient.post('/applications', data),
  getAll: (params = {}) => apiClient.get('/applications', { params }),
  updateStatus: (id, status) => apiClient.put(`/applications/${id}/status?status=${status}`),
};

// Content API
export const contentApi = {
  getTestimonials: () => apiClient.get('/testimonials'),
  getCaseStudies: () => apiClient.get('/case-studies'),
  getStats: () => apiClient.get('/stats'),
};

// Health check
export const healthCheck = () => apiClient.get('/health');

export default apiClient;
